import { Component, OnInit } from '@angular/core';
import { LogService } from '../../log.service';
import { DocumentService } from '../../document/document.service';
import { FetchDocumentsMessage, FetchDocumentsResult, SourceDocumentIdentifier } from '../../document/document.model';
import { MessageService } from 'src/app/messages/message.service';
import { File360Resources } from 'src/app/resources';
import { MessageType, HeaderBarMessageHeaderInfo } from 'src/app/messages/message.model';
import { CommandService, api } from 'src/app/command.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/user.service';
import { Utils } from 'src/app/utils';
import { Title } from '@angular/platform-browser';
import { File360Component } from 'src/app/component.model';
import { ConfigService } from 'src/app/config.service';
import { Config } from 'src/app/config.model';
import { from } from 'rxjs';
import { PermissionItem } from 'src/app/shared/permissionitem.model';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
declare function myViewer(webServer: string, apiCall: string, cookie: string, beservid: string, compid: string, uivariant: string, filecount: string, description: string): void;

@Component({
  selector: 'file360-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.scss']
})
export class ViewerComponent extends OnDestroyMixin implements OnInit {

  index: number = 0;

  constructor(private log: LogService,
    private documentService: DocumentService,
    private command: CommandService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private titleService: Title,
    public userService: UserService,
    private configService: ConfigService) {
    //required for componentDestroyed()
    super();
  }

  config: Config | undefined;
  //workflow help 
  wfhelp: number = 0;


  ngOnInit() {

    this.userService.componentInit$.next(new File360Component(File360Resources.componentTitleViewer));

    this.route.paramMap.subscribe(p => {
      //
      // Get documents list, version(s), annotation, annotation user, annotation group from paramMap
      //
      let documents = p.get('documents') as string;
      this.log.logMessage('The document id(s) ' + documents);
      let versions = p.get('versions') as string;
      this.log.logMessage('The version number(s) ' + versions);
      let annotate = p.get('annotate') as string;
      this.log.logMessage('Annotate is set to' + annotate);
      let annotateUserId = p.get('annotateUserId') as string;
      this.log.logMessage('Annotate user is set to' + annotateUserId);
      let annotateGrpId = p.get('annotateGroupId') as string;
      this.log.logMessage('Annotate group is set to' + annotateGrpId);
      let workitemId = p.get('workitemId') as string;
      this.log.logMessage('WorkitemId is ' + workitemId);
      if (workitemId) {
        this.wfhelp = 1;
      }
      this.getDocInfo(documents, versions, annotate, annotateUserId, annotateGrpId)
    });

    //setting workflow dataentry viewer page help
    if (this.wfhelp) {
      this.configService.setHelpUrl("workdataentry")
      this.configService.configLoaded$.pipe(takeUntil(componentDestroyed(this))).subscribe(
        config => {
          this.config = config as Config;
          //setting workflow dataentry viewer page help
          this.configService.setHelpUrl("workdataentry");
        },
        error => {
          this.log.logMessage(`Error loading config : '${error.Message}'`);
          console.error(error);
        });
    } else {
      this.configService.setHelpUrl("viewer")
      this.configService.configLoaded$.pipe(takeUntil(componentDestroyed(this))).subscribe(
        config => {
          this.config = config as Config;
          //setting Viewer page help
          this.configService.setHelpUrl("viewer");
        },
        error => {
          this.log.logMessage(`Error loading config : '${error.Message}'`);
          console.error(error);
        });
    }
  }

  public getDocInfo(ids: string, vids: string, annotate: string, annotateUserId: string, annotateGrpId: string) {
    this.log.logMessage(`getDocInfo(); enter`);
    //
    // Using selectedSourceDocuments to filter out duplicates due to suffixes
    //
    if (ids.length > 0) {
      //
      // Create message and view the document.
      //
      let message: FetchDocumentsMessage = new FetchDocumentsMessage();

      //
      // we only set annotate if we DON'T want to show the annotations
      //
      if (annotate !== null && annotate !== '') {
        if (annotate.toLowerCase() == 'false') {
          message.ApplyAnnotations = false;
        }
      }

      if (annotateUserId !== null && annotateUserId !== '') {
        message.RenderAsUserId = parseInt(annotateUserId);
      }
      if (annotateGrpId !== null && annotateGrpId !== '') {
        message.RenderAsGroupId = parseInt(annotateGrpId);
      }
      //
      // split the master IDs
      //
      let mid = ids.split(',');
      //
      // split the version numbers
      //
      if (vids) {
        var vid = vids.split(',');
      }
      //
      // Parse through the master & version ids and add them to the list
      //
      mid.forEach(ielement => {
        let doc: SourceDocumentIdentifier = new SourceDocumentIdentifier();
        doc.MasterId = parseInt(ielement);
        if (vid == null) {
          this.log.logMessage(`No Version`);
          doc.Version = 0;  // Not from the versions dialog
          message.DocumentsToFetch.push(doc);
        } else if (vid.length == 1) {
          this.log.logMessage(`Only 1 version selected`);
          doc.Version = parseInt(vid[0]);
          message.DocumentsToFetch.push(doc); //From the versions dialog only one version selected
        } else if (vid.length > 1) {
          this.log.logMessage(`Multiple versions selected`);
          vid.forEach(velement => {
            let doc: SourceDocumentIdentifier = new SourceDocumentIdentifier();
            doc.MasterId = parseInt(ielement);
            doc.Version = parseInt(velement);
            message.DocumentsToFetch.push(doc); //From the versions dialog with multiple versions selected.
          })
        }
      });


      this.documentService.fetch(message).subscribe(
        r => {
          const result = r as FetchDocumentsResult;

          if (result.ViewerUrl == "") {
            //Post headerbar error and download file
            let hbm_HeaderInfo: HeaderBarMessageHeaderInfo = new HeaderBarMessageHeaderInfo();
            if (this.userService.currentUser.getPermission(PermissionItem.EnableExternalViewer)) {
              hbm_HeaderInfo.setAsError(File360Resources.Message_UnableToViewDocumentAndDownload);
              this.messageService.showHeaderBarMessage(hbm_HeaderInfo);
              //Call the viewer download
              this.viewerDownload(result);
            } else {
              // No permission to download document, just display error.
              hbm_HeaderInfo.setAsError(File360Resources.Message_UnableToViewDocument);
              this.messageService.showHeaderBarMessage(hbm_HeaderInfo);
            }
          } else if (result.ViewerUrl == "ext") {
            let hbm_HeaderInfo: HeaderBarMessageHeaderInfo = new HeaderBarMessageHeaderInfo();
            if (this.userService.currentUser.getPermission(PermissionItem.EnableExternalViewer)) {
              //Call the open external
              this.openFileExternal(result);
            } else {
              // No permission to download document, just display error.
              hbm_HeaderInfo.setAsError(File360Resources.Message_UnableToViewDocument);
              this.messageService.showHeaderBarMessage(hbm_HeaderInfo);
            }

          } else {
            this.log.logMessage('The returned viewerUrl is ' + result.ViewerUrl);
            //split the return string
            let splitted = result.ViewerUrl.split('&', 4);
            let count = result.DocumentResult.length;

            //Setting the viewer title area
            if (count >= 3) {
              splitted.push(result.DocumentResult[0].Description + ' and ' + (count - 1).toString() + ' others');
            } else if (count == 2) {
              splitted.push(result.DocumentResult[0].Description + ' and 1 other');
            } else if (count == 1) {
              splitted.push(result.DocumentResult[0].Description);
            }

            this.launchViewer(splitted);
            if (this.index < 0) {
              //Get original title
              let tabTitle = this.titleService.getTitle();

              //adding selected documnet data to title
              if (count >= 3) {
                this.titleService.setTitle(tabTitle.toString() + ' – ' + result.DocumentResult[0].Description + ' and ' + (count - 1).toString() + ' others');
              } else if (count == 2) {
                this.titleService.setTitle(tabTitle.toString() + ' – ' + result.DocumentResult[0].Description + ' and 1 other');
              } else if (count == 1) {
                this.titleService.setTitle(tabTitle.toString() + ' – ' + result.DocumentResult[0].Description);
              }
            }
          }
        },
        error => {
          this.messageService.showModalMessage(File360Resources.ErrorMessage_Retrieve,
            File360Resources.errorViewDocuments(error.Message),
            MessageType.Error,
            File360Resources.Close,
            "",
            File360Resources.Close).subscribe();
        });

    }
  }

  public launchViewer(vparms: string[]) {
    this.log.logMessage(`launchViewer(); enter`);
    // the URL
    let webServer: string = "";
    let returnPath: string = window.location.href;
    // get index if you are coming here from the workflow list
    this.index = returnPath.lastIndexOf("home/index/(template");
    // if we have an index must be from workflow
    if (this.index > 0) {
      webServer = returnPath.substring(0, this.index);
    } else {
      // no index must be from retrieval
      webServer = Utils.getPath(window.location.href);
    }
    this.log.logMessage('The web server is ' + webServer);
    let apiCall: string = this.command.getUrl(api.DocumentSignedConfig);
    this.log.logMessage('The api call is ' + apiCall);
    let cookie: string = this.userService.currentUser.UniqueId;
    this.log.logMessage('The cookie is ' + cookie);
    let beservid: string = vparms[0];
    this.log.logMessage('The beservid is ' + beservid);
    let compid: string = vparms[1];
    this.log.logMessage('The compid is ' + compid);
    let uivariant: string = vparms[2];
    this.log.logMessage('The uivariant is ' + uivariant);
    let filecount: string = vparms[3];
    this.log.logMessage('The filecount is ' + filecount);
    let description: string = vparms[4];
    this.log.logMessage('The description is ' + description);
    this.log.logMessage(`Calling myViewer`);
    myViewer(webServer, apiCall, cookie, beservid, compid, uivariant, filecount, description);
  }

  private viewerDownload(result: FetchDocumentsResult) {
    const downloadpages = result.DocumentResult;
    const returnPath = window.location.href;
    const index = returnPath.lastIndexOf("viewer");
    //remove retrieve from path, leaving the virtual directory path
    const webServer = returnPath.substring(0, index);
    this.log.logMessage('The download webserver is ' + webServer);
    from(downloadpages.map(pages => {
      from(pages.UrlPages.map(page => {
        const webpage = webServer + page.Value;
        this.log.logMessage('The download webpage is ' + webpage);
        this.documentService.downloadFile(webpage).subscribe(
          data => {
            const blob = data as Blob;
            let description = webpage.replace(/^.*(\\|\/|\:)/, '');
            const ext = blob.type.indexOf('zip') > 0 ? "zip" : "pdf";
            Utils.downloadBlob(data, `${description}.${ext}`);
          },
          error => {
            let hbm_HeaderInfo: HeaderBarMessageHeaderInfo = new HeaderBarMessageHeaderInfo();
            hbm_HeaderInfo.setAsError(File360Resources.unableToDownloadFile(webpage));
            this.messageService.showHeaderBarMessage(hbm_HeaderInfo);
          }
        );
      }))
    }))
  }

  private openFileExternal(result: FetchDocumentsResult) {
    const downloadpages = result.DocumentResult;
    const returnPath = window.location.href;
    const index = returnPath.lastIndexOf("viewer");
    //remove retrieve from path, leaving the virtual directory path
    const webServer = returnPath.substring(0, index);
    this.log.logMessage('The download webserver is ' + webServer);
    from(downloadpages.map(pages => {
      from(pages.UrlPages.map(page => {
        const webpage = webServer + page.Value;
        this.log.logMessage('The file webpage is ' + webpage);
        window.open(webpage, '_self');
      }))
    }))
  }

}
